import { RouteDetailsRequestModel } from "api/lokiRequestModels/route/RouteDetailsRequestModel";
import { LynxTable } from "components/LynxTable/LynxTable";
import { dateEndFormatting, dateStartFormatting } from "helpers/dateFormatting";
import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import { useStore } from "store/StoreConfigs";
import { laneViewRoutesTableColumns } from "./LaneViewRoutesTableColumns";

export const LaneViewRoutesTableWrapper = observer(function TableWrapper() {
    const { laneStore, filtersStore, identityStore } = useStore();
    const { laneId } = useParams<any>();

    const onSortChange = (id: string, sortDirection: "ASC" | "DESC") => {
        laneStore.setRouteSortProperty(id);
        laneStore.setRouteDirection(sortDirection);
    };

    const onPageChange = (direction: "back" | "forward") => {
        if (direction === "back") {
            laneStore.moveToPreviousRoutePage();
        } else {
            const request: RouteDetailsRequestModel = {
                startTime: dateStartFormatting(filtersStore.startDate),
                endTime: dateEndFormatting(filtersStore.endDate),
                laneId,
                customerId: identityStore.currentCustomerId,
                lsp: filtersStore.selectedLogisticsServiceProviders.join(",") || undefined,
                productType: filtersStore.selectedProductTypes.join(",") || undefined,
                riskLevel: filtersStore.selectRiskLevels.join(",") || undefined,
                transportationModes: filtersStore.selectedModesOfTransportation.join(",") || undefined,
                packagingType: filtersStore.selectedPackagingTypes.join(",") || undefined,
                nextToken: laneStore.routeNextToken,
                sort: laneStore.sortRoute,
                direction: laneStore.directionRoute,
            };
            laneStore.moveToNextRoutesPage(request);
        }
    };

    return (
        <LynxTable
            columns={laneViewRoutesTableColumns}
            rows={laneStore.routePages.length === 0 ? [] : laneStore.routePages[laneStore.currentRoutePage - 1]}
            rowKey="routeId"
            page={laneStore.currentRoutePage}
            isLastPage={laneStore.isLastRoutePage}
            onPageChange={onPageChange}
            sortedBy={laneStore.sortRoute}
            sortDirection={laneStore.directionRoute}
            onSortChange={onSortChange}
            isLoading={laneStore.loadingRoutes}
        />
    );
});
